import*as _0x14afaa from'react';import _0x2aaafd from'./FormControlContext';export default function useFormControl(){return _0x14afaa['useContext'](_0x2aaafd);}